import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  previousEntryParent: belongsTo('entry', { inverse: 'previousEntries' }),
  previousEntries: hasMany('entry', { inverse: 'previousEntryParent' }),
  signedAgreementsJob: belongsTo('signed-agreements-job'),
  location: belongsTo('location'),
  device: belongsTo('device'),
  flow: belongsTo('flow'),
  signOutDevice: belongsTo('device'),
  invite: belongsTo('invite'),
  platformJobs: hasMany('platform-job'),
  groupParent: belongsTo('entry', { inverse: 'additionalGuestEntries' }),
  signInUser: belongsTo('user'),
  additionalGuestEntries: hasMany('entry', { inverse: 'groupParent' }),
  reservations: hasMany('reservation'),
  visitorDocuments: hasMany('visitor-document'),
  inviteMultiTenancyVisitorNotificationLogs: hasMany('notification-log', { inverse: null }),
  employee: belongsTo('employee'),
  additionalHosts: hasMany('employee', { inverse: null }),
  agreeableNdas: hasMany('agreeable-nda'),
});
